import React from 'react';
import './Stats.css';

const Stats = () => {
  return (
    <section className="stats section">
      <div className="container">
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon">
              <i className="fas fa-calendar-alt"></i>
            </div>
            <div className="stat-content">
              <div className="stat-number">4+</div>
              <div className="stat-label">Years of Experience</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon">
              <i className="fas fa-boxes"></i>
            </div>
            <div className="stat-content">
              <div className="stat-number">5 Million</div>
              <div className="stat-label">Bags Produced Per Annum</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon">
              <i className="fas fa-globe-americas"></i>
            </div>
            <div className="stat-content">
              <div className="stat-number">6</div>
              <div className="stat-label">States Served</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon">
              <i className="fas fa-user-friends"></i>
            </div>
            <div className="stat-content">
              <div className="stat-number">150+</div>
              <div className="stat-label">Total Employees</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
